import { Store } from '@ngrx/store';
import {
   Component,
   ElementRef,
   OnDestroy,
   OnInit,
   Renderer2,
   ViewChild,
} from '@angular/core';
import { AuthService } from '../../services/auth.service';
import * as authActions from '../../authModule/state/actions/authentication.actions';
import { getCurrentUser } from 'src/app/authModule/state/authentication.selectors';
// import { TawkService } from 'src/app/services/tawk.service';
import * as userActions from '../../authModule/state/actions/authentication.actions';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
/**
 * Header component
 */
@Component({
   selector: 'app-header',
   templateUrl: './header.component.html',
   styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
   /**
    * Method used to store user role.
    */
   userRole;
   /**
    * Used to store
    */
   user$: Subscription;
   user;
   expandedMenu: boolean;
   @ViewChild('name') name: ElementRef;
   @ViewChild('chevron') chevron: ElementRef;
   removeInfoIndex: boolean;
   isLoggedInFromApp;

   hasToken = false;

    isPilotApp = false;

   /**
    * Component Constructor
    * @param authService
    * @param store
    */
   constructor(
      private renderer: Renderer2,
      private authService: AuthService,
      private store: Store,
      // private tawkService: TawkService,
      private router: Router
   ) {
      this.renderer.listen('window', 'click', (e: Event) => {
         if (
            e.target !== this.name.nativeElement &&
            e.target !== this.chevron.nativeElement
         ) {
            this.expandedMenu = false;
         }
      });
   }
   ngOnDestroy(): void {
      if (this.user$) {
         this.user$.unsubscribe();
      }
   }
   /**
    * Method used to be called whenever the component is loaded and all the methods in it, will be triggered.
    */
   ngOnInit(): void {
      this.isLoggedInFromApp = localStorage.getItem('login-app') || false
      this.userRole = this.authService.isLoggedInRole();
      this.updateTokenStatus();

      this.user$ = this.store.select(getCurrentUser).subscribe((data) => {
         if (data !== null) {
            this.user = data;
            // Update login app status when user data changes (after MFA completion)
            this.isLoggedInFromApp = localStorage.getItem('login-app') || false;
         }

         // Update token status when user data changes
         this.updateTokenStatus();
      });
      this.expandedMenu = false;
      this.isPilotApp = environment.pilotApp
   }

   /**
    * A lifecycle hook that is called after Angular has fully initialized a component's view.
    */
   ngAfterViewInit(): void {
      this.user$ = this.store.select(getCurrentUser).subscribe((data) => {
         if (data !== null) {
            this.user = data;
         }
      });
   }

   private updateTokenStatus(): void {
      this.hasToken = !!this.authService.getUserToken();
   }

   goHome() {
      if(this.isPilotApp) {
        this.router.navigate(['/professor/submissions']);
      } else {
         this.router.navigate(['/']);
      }
   }
   /**
    * Method used to sign out and then redirect to login
    */
   signOut() {
      // this.tawkService.SetChatVisibility(false);
      this.store.dispatch(authActions.logout());
   }
   expandMenu() {
      if (this.expandedMenu) {
         this.expandedMenu = false;
      } else {
         this.expandedMenu = true;
      }
   }

   goToHelpCenter() {
    window.open("https://support.inspera.com/hc/no/categories/15848147005085-Inspera-Originality", "_blank");
  }

   removeInfo(){
      this.removeInfoIndex=true;
   }

   /**
    * Force refresh user data from API
    */
   forceRefreshUser(): void {
      this.store.dispatch(userActions.currentUser());
   }
}
